import { CardString } from 'pokersolver'
import React from 'react'
import { StyleSheet, Text, View } from 'react-native'

import { fontFamily } from '../../theme'
import { Card } from '../TempNewDesign/Card'
import { Dimensions } from 'react-native'

const PlayHands = () => {
  const cards: CardString[] = ['Kh', 'Js', '5d', '5s', '8c', '9c']
  const windowWidth = Dimensions.get('window').width

  return (
    <View style={styles.container}>
      <View style={styles.handContainer}>
        <View style={styles.hand}>
          <Card
            card={cards[0]}
            fontSize={windowWidth < 380 ? 20 : 24}
            cardStyle={{ borderWidth: 1.5 }}
            cardTextStyle={{ fontFamily: fontFamily.FeatureDeckRegular }}
          />
          <Card
            card={cards[1]}
            fontSize={windowWidth < 380 ? 20 : 24}
            cardStyle={{ borderWidth: 1.5 }}
            cardTextStyle={{ fontFamily: fontFamily.FeatureDeckRegular }}
          />
        </View>
        <Text style={styles.handText}>{'Two High\nCards'}</Text>
      </View>
      <View style={styles.handContainer}>
        <View style={styles.hand}>
          <Card
            card={cards[2]}
            fontSize={windowWidth < 380 ? 20 : 24}
            cardStyle={{ borderWidth: 1.5 }}
            cardTextStyle={{ fontFamily: fontFamily.FeatureDeckRegular }}
          />
          <Card
            card={cards[3]}
            fontSize={windowWidth < 380 ? 20 : 24}
            cardStyle={{ borderWidth: 1.5 }}
            cardTextStyle={{ fontFamily: fontFamily.FeatureDeckRegular }}
          />
        </View>
        <Text style={styles.handText}>Pairs</Text>
      </View>

      <View style={styles.handContainer}>
        <View style={styles.hand}>
          <Card
            card={cards[4]}
            fontSize={windowWidth < 380 ? 20 : 24}
            cardStyle={{ borderWidth: 1.5 }}
            cardTextStyle={{ fontFamily: fontFamily.FeatureDeckRegular }}
          />
          <Card
            card={cards[5]}
            fontSize={windowWidth < 380 ? 20 : 24}
            cardStyle={{ borderWidth: 1.5 }}
            cardTextStyle={{ fontFamily: fontFamily.FeatureDeckRegular }}
          />
        </View>
        <Text style={styles.handText}>{'Suited\nConnectors'}</Text>
      </View>
    </View>
  )
}

export default PlayHands

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 24
  },
  handContainer: {},
  hand: {
    flexDirection: 'row',
    gap: 4
  },
  handText: {
    textAlign: 'center',
    marginTop: 8,
    fontFamily: fontFamily.GTAmericaExtendedMedium
  }
})
